const NATIVELY_FOCUSABLE_TAGS = new Set(['BUTTON', 'A', 'INPUT', 'SELECT', 'TEXTAREA']);

export function focusElement(element) {
    if (!element || typeof element.focus !== 'function') {
        return;
    }

    if (!NATIVELY_FOCUSABLE_TAGS.has(element.tagName) && !element.hasAttribute('tabindex')) {
        element.tabIndex = -1;
    }

    element.focus({preventScroll: false});
}

export function focusCurrentTarget(event) {
    focusElement(event.currentTarget);
}

export function withFocusOnClick(handler) {
    if (!handler) {
        return focusCurrentTarget;
    }

    return (event) => {
        focusCurrentTarget(event);
        handler(event);
    };
}

const INTERACTIVE_CLICK_SELECTOR = [
    'button:not([disabled])',
    'a[href]',
    '.menu-button',
    '.submenu-button',
    '.table-row-actions-menu-item',
    '.table-row-actions-menu-trigger',
    '.action-icon-button',
    '.list-page-filters-toggle',
    '.whatsapp-button',
].join(', ');

export function focusInteractiveClickTarget(event) {
    const target = event.target.closest(INTERACTIVE_CLICK_SELECTOR);
    if (target) {
        focusElement(target);
    }
}

/** @deprecated use focusInteractiveClickTarget */
export const focusMenuClickTarget = focusInteractiveClickTarget;
